(function () {
	const productsPerRow = () => {
		// Preload from localStorage
		const savedPerRow = localStorage.getItem("productsPerRow");
		if (savedPerRow) {
			const activeBtn = $(`.per-row__button[data-per-row="${savedPerRow}"]`);
			if (activeBtn.length > 0) {
				$(".per-row__button").removeClass("active");
				activeBtn.addClass("active");
			}
			$('[data-productis-in-row]').attr("data-productis-in-row", savedPerRow);
		}

		$(document).on("click", ".per-row__button", function () {
			const perRow = $(this).data("per-row");
			$(".per-row__button").removeClass("active");
			$(`.per-row__button[data-per-row="${perRow}"]`).addClass("active");
			$('[data-productis-in-row]').attr("data-productis-in-row", perRow);
			localStorage.setItem("productsPerRow", perRow);
		});
	};

	document.addEventListener("shopify:section:load", function () {
		productsPerRow();
	});
	productsPerRow();
})();
